const AUTH_EXPIRED_EVENT = 'app:auth-expired';
const UNAUTHORIZED_ERROR_CODE = 'AUTH_UNAUTHORIZED';

export { AUTH_EXPIRED_EVENT, UNAUTHORIZED_ERROR_CODE };

export function clearStoredAuth() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authUser');
}

export function notifyAuthExpired(detail = {}) {
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT, { detail }));
}

export function createUnauthorizedError() {
  const error = new Error('Authentication required');
  error.code = UNAUTHORIZED_ERROR_CODE;
  return error;
}

export function isUnauthorizedError(error) {
  return error?.code === UNAUTHORIZED_ERROR_CODE;
}

export function getAuthHeaders(headers = {}) {
  const token = localStorage.getItem('authToken');
  return token ? { ...headers, Authorization: `Bearer ${token}` } : headers;
}

async function parseResponseBody(response) {
  const responseText = await response.text();

  if (responseText.trim() === '') {
    return null;
  }

  try {
    return JSON.parse(responseText);
  } catch (error) {
    return responseText;
  }
}

export async function fetchJson(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: getAuthHeaders(options.headers),
  });

  if (response.status === 401) {
    clearStoredAuth();
    notifyAuthExpired({ url, status: response.status });
    throw createUnauthorizedError();
  }

  const payload = await parseResponseBody(response);

  if (!response.ok) {
    const errorMessage =
      payload && typeof payload === 'object'
        ? payload.message || payload.error
        : null;

    throw new Error(errorMessage || `HTTP ${response.status}`);
  }

  return payload;
}
